import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/views/TermsPage.tsx");
